import React, { useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "../lib/api";
import { Seo } from "../lib/seo";
import { Section, SectionHead } from "../components/ui";
import { TestimonialWall, RatingHistogram } from "../components/marketing";
import { useReveal } from "../lib/useReveal";

export default function Reviews() {
  const { data: all } = useQuery({ queryKey: ["all-testimonials"], queryFn: () => get("/testimonials") });
  const { data: summary } = useQuery({ queryKey: ["reviews-summary"], queryFn: () => get("/reviews-summary") });
  const [rating, setRating] = useState("");
  const [vertical, setVertical] = useState("");
  const [channel, setChannel] = useState("");
  useReveal(all);

  const items = all || [];
  const verticals = useMemo(() => [...new Set(items.map((t) => t.vertical).filter(Boolean))], [items]);
  const channels = useMemo(() => [...new Set(items.map((t) => t.channel).filter(Boolean))], [items]);
  const filtered = items.filter((t) =>
    (!rating || t.rating === Number(rating)) && (!vertical || t.vertical === vertical) && (!channel || t.channel === channel));

  return (
    <>
      <Seo title="Reviews" path="/reviews/" description="Real BloomCONNECT reviews from teams selling in the DMs — the good, the critical, and our responses to both."
        jsonLd={summary ? { "@context": "https://schema.org", "@type": "Product", name: "BloomCONNECT", aggregateRating: { "@type": "AggregateRating", ratingValue: summary.average, reviewCount: summary.count } } : null} />
      <Section>
        <SectionHead label="Reviews" title="Don't take our word for it. Take theirs." />
        <div className="mt-8">{summary && <RatingHistogram summary={summary} />}</div>
      </Section>
      <Section sunk>
        <div className="flex flex-wrap gap-4 mb-8">
          {[["Rating", rating, setRating, ["5", "4", "3", "2", "1"]], ["Vertical", vertical, setVertical, verticals], ["Channel", channel, setChannel, channels]].map(([label, val, setter, opts]) => (
            <label key={label} className="text-sm">
              <span className="eyebrow block mb-1">{label}</span>
              <select value={val} onChange={(e) => setter(e.target.value)} className="rounded-xs border border-line px-3 h-10 bg-white text-sm min-w-[160px]">
                <option value="">All</option>
                {opts.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </label>
          ))}
        </div>
        {filtered.length > 0 ? <TestimonialWall items={filtered} /> : <p className="text-ink-400">No reviews match those filters.</p>}
      </Section>
    </>
  );
}
